/*-----------------------------------------------------------------------------------
    
    Template Name: Pesco - eCommerce HTML Template
    URI: site.com 
    Description: Pesco is a clean, modern, and elegant fashion e-commerce HTML template. It allows you to easily create a well-designed e-commerce website that is easily customizable to fit your brand colors and requirements.
    Author: Pixelfit
    Author URI: https://themeforest.net/user/pixelfit
    Version: 1.0 

    Note: This is Main Js file
-----------------------------------------------------------------------------------
    Js INDEX
    ===================
    ## Main Menu
    ## Document Ready
    ## Nav Overlay
    ## Preloader
    ## Sticky
    ## Back to top
    ## Magnific-popup js
    ## Nice select
    ## Slick Slider
    ## Quantity Number js
    ## Jquery Slider Range
    ## Simply Countdown Js
    ## Show More Active JS
    ## AOS Js
    
-----------------------------------------------------------------------------------*/

(function($) {
    'use strict';

    function closeHeaderSearchNiceSelect() {
        $('.product-search-category .nice-select.open').removeClass('open');
    }

    //===== Main Menu
    function mainMenu() {
        
        // Variables
        var var_window = $(window),
        navContainer = $('.header-navigation'),
        navbarToggler = $('.navbar-toggler'),
        navMenu = $('.pesco-nav-menu'),
        navMenuLi = $('.pesco-nav-menu ul li ul li'),
        closeIcon = $('.navbar-close');

        // navbar toggler

        navbarToggler.on('click', function() {
            navbarToggler.toggleClass('active');
            navMenu.toggleClass('menu-on');
            if (navMenu.hasClass('menu-on')) {
                closeHeaderSearchNiceSelect();
                $('.sidemenu-wrapper-cart').removeClass('info-open');
                $('.offcanvas__overlay').removeClass('overlay-open');
                $('body').addClass('mobile-nav-open');
            } else {
                $('body').removeClass('mobile-nav-open');
            }
        });

        // close icon

        closeIcon.on('click', function() {
            navMenu.removeClass('menu-on');
            navbarToggler.removeClass('active');
            $('.offcanvas__overlay').removeClass('overlay-open');
            $('body').removeClass('mobile-nav-open');
        });

        // adds toggle button to li items that have children

        navMenu.find("li a").each(function() {
            if ($(this).children('.dd-trigger').length < 1) {
                if ($(this).next().length > 0) {
                    $(this).append('<span class="dd-trigger"><i class="far fa-angle-down"></i></span>')
                }
            }
        });
        
        // expands the dropdown menu on each click

        navMenu.find(".dd-trigger").on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if ($(window).width() > 991) return;
            $(this).parent().parent().siblings().children('ul.sub-menu').slideUp();
            $(this).parent().next('ul.sub-menu').stop(!0, !0).slideToggle(350);
            $(this).toggleClass('sub-menu-open')
        });

    };
    
    // Offcanvas Overlay

    function offCanvas(){
        $(document).on('click', '.cart-button', function(e) {
            if (isCartDrawerOpen()) {
                e.preventDefault();
                closeCartDrawer();
                return;
            }
            $('.navbar-toggler').removeClass('active');
            $('.pesco-nav-menu').removeClass('menu-on');
            $('body').removeClass('mobile-nav-open');
            openCartDrawer();
        });
        $(document).on('click', '.offcanvas__overlay', function() {
            $('.navbar-toggler').removeClass('active');
            $('.pesco-nav-menu').removeClass('menu-on');
            $('body').removeClass('mobile-nav-open');
            closeCartDrawer();
        });
        $(document).on('click', '.sidemenu-cart-close', function() {
            closeCartDrawer();
        });
    }

    function cartApiRoot() {
        return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    }

    function closeCartDrawer() {
        $('#cart-drawer, .sidemenu-wrapper-cart').removeClass('info-open');
        $('.offcanvas__overlay').removeClass('overlay-open');
    }

    function openCartDrawer() {
        var drawer = document.getElementById('cart-drawer');
        if (drawer) drawer.classList.add('info-open');
        $('.sidemenu-wrapper-cart').addClass('info-open');
        $('.offcanvas__overlay').addClass('overlay-open');
        closeHeaderSearchNiceSelect();
    }

    function isCartDrawerOpen() {
        var drawer = document.getElementById('cart-drawer');
        return !!(drawer && drawer.classList.contains('info-open'));
    }

    function refreshCartDrawerSection(options) {
        options = options || {};
        var current = document.getElementById('cart-drawer');
        var keepOpen = options.keepOpen === true
            || (current && current.classList.contains('info-open'));
        return fetch(cartApiRoot() + '?sections=header')
            .then(function(res) { return res.json(); })
            .then(function(data) {
                var html = data && data.header;
                if (!html) return;
                var wrap = document.createElement('div');
                wrap.innerHTML = html;
                var newDrawer = wrap.querySelector('#cart-drawer');
                if (newDrawer && current) {
                    if (keepOpen) {
                        newDrawer.classList.add('info-open');
                        $('.offcanvas__overlay').addClass('overlay-open');
                    } else {
                        closeCartDrawer();
                    }
                    current.replaceWith(newDrawer);
                }
                var newCount = wrap.querySelector('.js-cart-count');
                document.querySelectorAll('.js-cart-count').forEach(function(el) {
                    if (newCount) el.textContent = newCount.textContent;
                });
                var badge = wrap.querySelector('.js-cart-count-badge');
                document.querySelectorAll('.js-cart-count-badge').forEach(function(el) {
                    if (!badge) return;
                    if (badge.hasAttribute('hidden')) {
                        el.setAttribute('hidden', 'hidden');
                    } else {
                        el.removeAttribute('hidden');
                        el.textContent = badge.textContent;
                    }
                });
            });
    }

    function setCartLineQuantity(lineKey, quantity) {
        return fetch(cartApiRoot() + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: lineKey, quantity: quantity })
        }).then(function(res) {
            if (!res.ok) throw new Error('cart change failed');
            return res.json();
        });
    }

    var cartDrawerQtyBusy = false;

    function initAjaxAddToCart() {
        $(document).on('submit', 'form', function(e) {
            var form = $(this);
            if (form.hasClass('js-deal-buy-now-form') || form.is('[data-deal-buy-now]')) {
                return;
            }
            var action = (form.attr('action') || '').toLowerCase();
            if (action.indexOf('/cart/add') === -1) return;
            e.preventDefault();
            var id = form.find('input[name="id"], select[name="id"]').val();
            if (!id) return;
            var qty = parseInt(form.find('input[name="quantity"]').val(), 10);
            if (isNaN(qty) || qty < 1) qty = 1;
            var btn = form.find('[type="submit"]');
            btn.prop('disabled', true);
            fetch(cartApiRoot() + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
            })
            .then(function(res) {
                if (!res.ok) throw new Error('add failed');
                return res.json();
            })
            .then(function() {
                return refreshCartDrawerSection();
            })
            .then(function() {
                openCartDrawer();
            })
            .catch(function() {
                form.off('submit').get(0).submit();
            })
            .finally(function() {
                btn.prop('disabled', false);
            });
        });
    }

    function cartDrawerAddons() {
        $(document).on('click', '.js-cart-addon-add', function(e) {
            e.preventDefault();
            var variantId = $(this).data('variant-id');
            if (!variantId) return;
            var btn = $(this);
            if (btn.prop('disabled')) return;
            btn.prop('disabled', true).text('Adding…');
            fetch(cartApiRoot() + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            })
            .then(function(res) {
                if (!res.ok) throw new Error('add failed');
                return res.json();
            })
            .then(function() {
                return refreshCartDrawerSection();
            })
            .then(function() {
                openCartDrawer();
                if ($('.cart-page-section').length) window.location.reload();
            })
            .catch(function() {
                btn.prop('disabled', false).text(btn.data('label') || 'Add');
            });
        });
        $(document).on('click', '.js-cart-drawer-qty', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (cartDrawerQtyBusy) return;
            var key = $(this).data('line-key');
            var delta = parseInt($(this).data('delta'), 10) || 0;
            var input = $('#cart-drawer .js-cart-drawer-qty-input[data-line-key="' + key + '"]');
            if (!input.length) return;
            var min = parseInt(input.attr('min'), 10);
            if (isNaN(min)) min = 0;
            var val = parseInt(input.val(), 10) || 0;
            var next = val + delta;
            if (next < min) next = min;
            cartDrawerQtyBusy = true;
            input.val(next);
            setCartLineQuantity(key, next)
                .then(function() {
                    return refreshCartDrawerSection({ keepOpen: true });
                })
                .then(function() {
                    openCartDrawer();
                })
                .finally(function() {
                    cartDrawerQtyBusy = false;
                });
        });
        var cartQtyTimer;
        $(document).on('change', '.js-cart-drawer-qty-input', function() {
            if (cartDrawerQtyBusy) return;
            var input = $(this);
            var key = input.data('line-key');
            var min = parseInt(input.attr('min'), 10);
            if (isNaN(min)) min = 0;
            var val = parseInt(input.val(), 10);
            if (isNaN(val) || val < min) val = min;
            input.val(val);
            clearTimeout(cartQtyTimer);
            cartQtyTimer = setTimeout(function() {
                cartDrawerQtyBusy = true;
                setCartLineQuantity(key, val)
                    .then(function() {
                        return refreshCartDrawerSection({ keepOpen: true });
                    })
                    .then(function() {
                        openCartDrawer();
                    })
                    .finally(function() {
                        cartDrawerQtyBusy = false;
                    });
            }, 400);
        });
        $('.js-cart-addon-add').each(function() {
            $(this).data('label', $(this).text().trim());
        });
    }

    // Document Ready
    $(function() {
        mainMenu();
        offCanvas();
        initAjaxAddToCart();
        cartDrawerAddons();
    });


    //===== Preloader — do not wait for every image/font
    function hidePreloader() {
        $('.preloader').stop(true, true).fadeOut(200);
        $('body').addClass('page-ready');
    }
    $(hidePreloader);
    setTimeout(hidePreloader, 600);

    
    //===== Sticky

    $(window).on('scroll', function(event) {
        var scroll = $(window).scrollTop();
        if (scroll < 100) {
            $(".header-navigation").removeClass("sticky");
        } else {
            $(".header-navigation").addClass("sticky");
        }
    });

    //===== Back to top

    $(window).on('scroll', function(event) {
        if ($(this).scrollTop() > 600) {
            $('.back-to-top').fadeIn(200)
        } else {
            $('.back-to-top').fadeOut(200)
        }
    });
    $('.back-to-top').on('click', function(event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: 0,
        }, 1500);
    });

    //===== Magnific-popup js
    
    if ($('.video-popup').length){
        $('.video-popup').magnificPopup({
            type: 'iframe',
            removalDelay: 300,
            mainClass: 'mfp-fade'
        });
    }

    if ($('.img-popup').length){
        $(".img-popup").magnificPopup({
            type: "image",
             gallery: { 
              enabled: true 
            }
        });
    }

    //===== Nice select js
    
    if ($('select').length){
        $('select').niceSelect();
    }
    
    //===== Slick slider js

    if ($('.hero-slider-one').length) {
        var sliderDots = $('.hero-dots');
        var $heroSlider = $('.hero-slider-one');
        var heroAutoplay = $heroSlider.attr('data-autoplay') !== 'false';
        var heroAutoplaySpeed = parseInt($heroSlider.attr('data-autoplay-speed'), 10) || 4000;
        $heroSlider.slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 800,
            appendArrows: sliderArrows,
            appendDots: sliderDots,
            autoplay: heroAutoplay,
            autoplaySpeed: heroAutoplaySpeed,
            pauseOnHover: true,
            vertical: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i><img src="//lushylife.store/cdn/shop/t/9/assets/arrow-right.png?v=80663142886646118381790014315" alt=""></div>',
            nextArrow: '<div class="next"><img src="//lushylife.store/cdn/shop/t/9/assets/arrow-right.png?v=80663142886646118381790014315" alt=""><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        dots: false
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        vertical: false,
                    }
                }
            ]
        });
    }
    if ($('.hero-post-slider').length) {
        var sliderDots = $('.hero-dots');
        $('.hero-post-slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 800,
            appendDots: sliderDots,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>'
        });
    }


    if ($('.category-slider-one').length) {
        var sliderArrows = $('.category-arrows');
        $('.category-slider-one').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 800,
            appendArrows: sliderArrows,
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    if ($('.feature-slider-one').length) {
        var sliderArrows = $('.feature-arrows');
        $('.feature-slider-one').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 800,
            appendArrows: sliderArrows,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    if ($('.trending-products-slider').length) {
        var sliderArrows = $('.trending-product-arrows');
        $('.trending-products-slider').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 800,
            appendArrows: sliderArrows,
            autoplay: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
    if ($('.today-deals-slider').length) {
        var sliderArrows = $('.today-deals-arrows');
        $('.today-deals-slider').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 800,
            centerMode: true,
            appendArrows: sliderArrows,
            autoplay: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        centerMode: false,
                        variableWidth: true,
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        variableWidth: true,
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        variableWidth: false
                    }
                }
            ]
        });
    }
    if ($('.testimonial-slider-one').length) {
        var sliderArrows = $('.testimonial-arrows');
        $('.testimonial-slider-one').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 800,
            appendArrows: sliderArrows,
            autoplay: true,
            slidesToShow: 1,
            variableWidth: true,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        variableWidth: false,
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
    if ($('.testimonial-slider-two').length) {
        $('.testimonial-slider-two').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 800,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>'
        });
    }
    if ($('.weekly-top-product-slider').length) {
        $('.weekly-top-product-slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 800,
            autoplay: true,
            slidesToShow: 3,
            variableWidth: true,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
    if ($('.team-slider-one').length) {
        var sliderDots = $('.team-slider-dots');
        var sliderArrows = $('.team-arrows');
        $('.team-slider-one').slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 800,
            appendArrows: sliderArrows,
            appendDots: sliderDots,
            autoplay: true,
            centerMode: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    if ($('.releted-product-slider').length) {
        var sliderArrows = $('.releted-product-arrows');
        $('.releted-product-slider').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 800,
            appendArrows: sliderArrows,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    if ($('.product-big-slider').length) {
        $('.product-big-slider').slick({
            dots: false,
            arrows: false,
            speed: 800,
            autoplay: true,
            fade: true,
            asNavFor: '.product-thumb-slider',
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="far fa-angle-left"></i></div>',
            nextArrow: '<div class="next"><i class="far fa-angle-right"></i></div>'
        });
    }
    if ($('.product-thumb-slider').length) {
        $('.product-thumb-slider').slick({
            dots: false,
            arrows: false,
            speed: 800,
            autoplay: true,
            asNavFor: '.product-big-slider',
            focusOnSelect: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="far fa-angle-left"></i></div>',
            nextArrow: '<div class="next"><i class="far fa-angle-right"></i></div>'
        });
    }

    if ($('.blogs-slider-one').length) {
        var sliderArrows = $('.blogs-arrows');
        $('.blogs-slider-one').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 800,
            appendArrows: sliderArrows,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow:1,
                    }
                }
            ]
        });
    }
    if ($('.instagram-slider-one').length) {
        $('.instagram-slider-one').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 800,
            appendArrows: sliderArrows,
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            prevArrow: '<div class="prev"><i class="flaticon-arrow-left"></i></div>',
            nextArrow: '<div class="next"><i class="flaticon-arrow-right"></i></div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow:1,
                    }
                }
            ]
        });
    }
    //======= Quantity Number js
    
    $(document).on('click', '.quantity-down', function(){
        if ($(this).closest('#cart-drawer').length) return;
        var input = $(this).next('.quantity');
        if (!input.length) return;
        var min = parseInt(input.attr('min'), 10);
        if (isNaN(min)) min = 1;
        var val = parseInt(input.val(), 10) || 0;
        if (val > min) input.val(val - 1);
    });
    $(document).on('click', '.quantity-up', function(){
        if ($(this).closest('#cart-drawer').length) return;
        var input = $(this).prev('.quantity');
        if (!input.length) return;
        var val = parseInt(input.val(), 10) || 0;
        input.val(val + 1);
    });

    $(document).on('click', '.js-cart-apply-discount', function() {
        var code = ($('#cart-discount-code').val() || '').trim();
        if (!code) {
            $('#cart-discount-code').focus();
            return;
        }
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });

    //===== Slider Range
    
    $( "#slider-range" ).slider({
        range: true,
        min: 0,
        max: 200,
        values: [ 19, 140 ],
        slide: function( event, ui ) {
          $( "#amount" ).val( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
        }
    });
    $( "#amount" ).val( "$" + $( "#slider-range" ).slider( "values", 0 ) + " - $" + $( "#slider-range" ).slider( "values", 1 ) );


    
        
    //===== Simply Countdown

    var countdownWords = {
        days: { singular: 'day', plural: 'Days' },
        hours: { singular: 'hour', plural: 'Hours' },
        minutes: { singular: 'minute', plural: 'Min' },
        seconds: { singular: 'second', plural: 'Sec' }
    };

    $('.js-deal-countdown').each(function () {
        var $el = $(this);
        simplyCountdown(this, {
            year: parseInt($el.data('year'), 10) || 2026,
            month: parseInt($el.data('month'), 10) || 12,
            day: parseInt($el.data('day'), 10) || 31,
            hours: parseInt($el.data('hours'), 10) || 0,
            minutes: parseInt($el.data('minutes'), 10) || 0,
            words: countdownWords
        });
    });

    $('.simply-countdown-two').each(function () {
        var $el = $(this);
        simplyCountdown(this, {
            year: parseInt($el.data('year'), 10) || 2026,
            month: parseInt($el.data('month'), 10) || 12,
            day: parseInt($el.data('day'), 10) || 31,
            hours: parseInt($el.data('hours'), 10) || 0,
            minutes: parseInt($el.data('minutes'), 10) || 0,
            words: countdownWords
        });
    });


    //===== Show More Burtton

    $(".more_slide_open").slideUp();
    $(".more_categories").on("click", function () {
        $(this).toggleClass("show");
        $(".more_slide_open").slideToggle();
    });

    //====== Aos JS

    if (typeof AOS !== 'undefined') {
        AOS.init({
            offset: 80,
            once: true,
            duration: 600,
            easing: 'ease-out',
            disableMutationObserver: true
        });
    }

})(window.jQuery);